import { render, staticRenderFns } from "./SubHeader.vue?vue&type=template&id=d0ba45b6&scoped=true"
import script from "./SubHeader.vue?vue&type=script&lang=js"
export * from "./SubHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0ba45b6",
  null
  
)

export default component.exports